import { useEffect, useMemo, useState } from 'react'
import type { V5Data } from '../../data/types'
import { alertsFromReport, buildAlertView, type AlertsFeed } from './model'
import { useLiveAlertFeed } from '../../shell/LiveAlerts'

/** Foundation can supply the live resource through the store when the reader lands. */
export type AlertsData = V5Data & { alertsFeed?: AlertsFeed }
export function useAlerts(data: AlertsData) {
  const [revision, setRevision] = useState(0)
  const live = useLiveAlertFeed()
  const independent = data.alertsFeed ?? live
  const feed = useMemo(() => independent ?? alertsFromReport(data.report), [independent, data.report])
  const now = data.mock && data.report ? Date.parse(data.report.current.time) : Date.now()
  const view = useMemo(() => buildAlertView(feed, now, { demo: data.mock, offline: data.offline, pending: !independent && data.pending }), [feed, independent, data.mock, data.offline, data.pending, now, revision])
  useEffect(() => {
    if (data.mock) return
    const update = () => setRevision(value => value + 1)
    const onVisible = () => { if (document.visibilityState === 'visible') update() }
    const delay = view.nextChange == null ? null : Math.max(1, view.nextChange - Date.now())
    const timer = delay != null && delay <= 2_147_483_647 ? window.setTimeout(update, delay) : null
    document.addEventListener('visibilitychange', onVisible)
    return () => { if (timer != null) window.clearTimeout(timer); document.removeEventListener('visibilitychange', onVisible) }
  }, [view.nextChange, data.mock, revision])
  return view
}
